export default {
  exists(type, id) {
    const state = window.history.state
    const expansions = state && state.expansions
    return expansions && expansions[type] && expansions[type].hasOwnProperty(id)
  },
  get(type, id) {
    const state = window.history.state
    const expansions = state && state.expansions
    return expansions && expansions[type] && expansions[type][id]
  },
  set(type, id, value) {
    const newState = { ...window.history.state }
    if (!newState.expansions) {
      newState.expansions = {}
    }
    const expansions = newState.expansions
    if (!expansions[type]) {
      expansions[type] = {}
    }
    expansions[type][id] = value
    window.history.replaceState(newState, '')
  }
}
